<b id="monthly-toggle" [ngClass]="{ active: !on }">Monthly</b>
<!-- The color="warn" attribute is used to give the toggle switch a warning color (typically red) to indicate its importance or potential impact. -->
<mat-slide-toggle (change)="onChange($event)" [checked]="on" color="warn">
</mat-slide-toggle>
<b id="annual-toggle" [ngClass]="{ active: on }">Annual</b>